<div class="w-100 position-relative">
  @if(ms.selectedMail()) {
  <div class="d-flex align-items-center p-x-16 p-y-8">
    <button mat-icon-button (click)="removeClass()" class="d-block d-lg-none">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="menu">
      <i-tabler name="arrow-badge-right" class="icon-20"></i-tabler>
    </button>

    <mat-menu #menu="matMenu" class="cardWithShadow">
      <button mat-menu-item class="p-l-0">
        @if(ms.selectedMail()?.label?.indexOf('Personal') !== -1) {
        <span>
          <mat-checkbox (click)="labelClick('Personal')" [checked]="true"
            >Personal</mat-checkbox
          >
        </span>

        } @if(ms.selectedMail()?.label?.indexOf('Personal') === -1) {
        <span>
          <mat-checkbox (click)="labelClick('Personal')">Personal</mat-checkbox>
        </span>
        }
      </button>
      <button mat-menu-item class="p-l-0">
        @if(ms.selectedMail()?.label?.indexOf('Work') !== -1) {
        <span>
          <mat-checkbox (click)="labelClick('Work')" [checked]="true"
            >Work</mat-checkbox
          >
        </span>
        } @if(ms.selectedMail()?.label?.indexOf('Work') === -1) {

        <span>
          <mat-checkbox (click)="labelClick('Work')">Work</mat-checkbox>
        </span>
        }
      </button>
      <button mat-menu-item class="p-l-0">
        @if(ms.selectedMail()?.label?.indexOf('Payments') !== -1) {
        <span>
          <mat-checkbox (click)="labelClick('Payment')" [checked]="true"
            >Payments</mat-checkbox
          >
        </span>
        } @if(ms.selectedMail()?.label?.indexOf('Payments') === -1) {
        <span>
          <mat-checkbox (click)="labelClick('Payment')">Payments</mat-checkbox>
        </span>
        }
      </button>
      <button mat-menu-item class="p-l-0">
        @if(ms.selectedMail()?.label?.indexOf('Accounts') !== -1) {
        <span>
          <mat-checkbox (click)="labelClick('Account')" [checked]="true"
            >Accounts</mat-checkbox
          >
        </span>
        } @if(ms.selectedMail()?.label?.indexOf('Accounts') === -1) {
        <span>
          <mat-checkbox (click)="labelClick('Account')">Accounts</mat-checkbox>
        </span>
        }
      </button>
    </mat-menu>

    <button
      mat-icon-button
      (click)="iconsClick('Important')"
      class="d-flex align-items-center justify-content-center"
    >
      @if(ms.selectedMail()?.filter?.includes('Important')){
      <i-tabler
        name="alert-circle-filled"
        class="icon-18 d-flex align-items-center text-error"
      >
      </i-tabler>
      }@else {
      <i-tabler
        name="alert-circle"
        class="icon-18 d-flex align-items-center"
      ></i-tabler>
      }
    </button>

    <button
      mat-icon-button
      class="d-flex align-items-center justify-content-center"
      (click)="iconsClick('Star')"
    >
      @if(ms.selectedMail()?.filter?.includes('Star')){
      <i-tabler
        name="star"
        class="icon-18 fill-warning d-flex align-items-center"
      >
      </i-tabler>
      } @else {
      <i-tabler
        name="star"
        class="icon-18 d-flex align-items-center"
      ></i-tabler>
      }
    </button>

    <div class="m-l-auto d-flex">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu1"
        class="d-flex justify-content-center"
      >
        <i-tabler name="dots-vertical" class="icon-20 d-flex"></i-tabler>
      </button>
      <mat-menu #menu1="matMenu" class="cardWithShadow">
        <button mat-menu-item (click)="ddlRemoveClick('Read')">
          <div class="d-flex align-items-center gap-8">
            <i-tabler name="mail" class="icon-18"></i-tabler>
            @if(ms.selectedMail()?.seen) {
            <span>Mark as unread</span>
            } @if(!ms.selectedMail()?.seen) {
            <span>Mark as read</span>
            }
          </div>
        </button>
        <button mat-menu-item (click)="ddlRemoveClick('Spam')">
          <div class="d-flex align-items-center gap-8">
            <i-tabler name="alert-triangle" class="icon-18"></i-tabler>
            Spam
          </div>
        </button>
        <button mat-menu-item (click)="ddlRemoveClick('Trash')">
          <div class="d-flex align-items-center gap-8">
            <i-tabler name="trash" class="icon-18"></i-tabler>Trash
          </div>
        </button>
      </mat-menu>
    </div>
  </div>
  }

  <mat-divider></mat-divider>

  <!-- -------------------------------------------------------------- -->
  <!-- if mail is selected -->
  <!-- -------------------------------------------------------------- -->
  @if(ms.selectedMail()) {
  <ng-scrollbar style="height: calc(100vh - 370px)" class="position-relative">
    <div class="p-24">
      <div class="d-flex align-items-center m-b-30 gap-10">
        <img
          [src]="ms.selectedUser().imagePath"
          class="rounded-circle"
          alt="userimg"
          width="40px"
          height="40px"
        />
        <div>
          <h5 class="m-0 f-w-600 f-s-16">
            {{ ms.selectedUser().name }}
          </h5>
          <span class="f-s-14"> {{ ms.selectedUser().email }}</span>
        </div>
        <div class="m-l-auto d-none d-sm-flex align-items-center gap-4">
          @for(l of ms.selectedMail()?.label; track l) {
          <span class="d-flex align-items-center gap-4">
            @if(l === 'Personal') {
            <span class="bg-primary rounded-pill p-x-8 p-y-2 text-white f-s-12">
              Personal
            </span>
            } @if(l === 'Work') {
            <span
              class="bg-secondary rounded-pill p-x-8 p-y-2 text-white f-s-12"
            >
              Work
            </span>
            } @if(l === 'Payments') {
            <span class="bg-error rounded-pill p-x-8 p-y-2 text-white f-s-12">
              Payment
            </span>
            } @if(l === 'Accounts') {
            <span class="bg-warning rounded-pill p-x-8 p-y-2 text-white f-s-12">
              Account
            </span>
            }
          </span>
          }
        </div>
      </div>
      <div class="f-s-21 p-y-24 f-w-500">
        {{ ms.selectedMail()?.Subject }}
      </div>
      <div class="m-b-24 f-s-14">
        {{ ms.selectedMail()?.Message }}
      </div>
      <div class="m-t-10">
        <!-- -------------------------------------------------------------- -->
        <!-- toggle reply -->
        <!-- -------------------------------------------------------------- -->

        @if(ms.replyShow()) {
        <div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Type your reply here</mat-label>
            <textarea matInput rows="5"></textarea>
          </mat-form-field>
          <button
            mat-flat-button
            class="bg-error text-white"
            (click)="sendButtonClick()"
          >
            Discard
          </button>
          <button mat-flat-button class="m-l-10" (click)="sendButtonClick()">
            Send
          </button>
        </div>
        } @if(!ms.replyShow()) {
        <div class="d-flex align-items-center gap-8">
          <button mat-flat-button (click)="reply()">Reply</button>
          <button mat-stroked-button (click)="reply()">Forward</button>
        </div>
        }
      </div>
    </div>
  </ng-scrollbar>
  }
</div>
